import { css } from "lit";

export const style = css`
	:host {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		position: relative;
		user-select: text;
	}

	#messages {
		padding: 0px 15px 15px 15px;
	}

	.no-messages {
		text-align: center;
		margin-top: 50px;
		color: var(--og-text-color);
		opacity: 0.6;
	}

	.system-message {
		margin: 12px;
		text-align: center;
		font-size: var(--og-font-size);
	}

	.message {
		display: flex;
		flex-direction: row;
		border: 1px solid var(--og-border-color);
		border-radius: var(--og-base-radius);
		margin-bottom: 10px;
		font-size: var(--og-font-size);
		user-select: text;
	}

	.message.rp {
		border-color: var(--og-colortype-accent-background-color);
	}

	.message-left {
		padding: 10px;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		flex: 0 0 40px;
		white-space: nowrap;
		border-right: 1px solid var(--og-border-color);
		gap: 6px;
	}

	.message-avatar {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 25px;
		height: 25px;
		border-radius: 50%;
		background: var(--og-colortype-gray-background-color);
		color: var(--og-colortype-gray-text-color);
		font-weight: bold;
		font-size: 10px;
		flex-shrink: 0;
	}

	.message.rp .message-avatar {
		background: var(--og-colortype-accent-background-color);
		color: var(--og-colortype-accent-text-color);
	}

	.message-name {
		font-size: 0.7em;
		max-width: 90px;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.message-time {
		font-size: 0.7em;
		opacity: 0.7;
		text-align: center;
	}

	.message-content {
		flex: 1;
		align-self: center;
		color: var(--og-text-color);
		padding: 5px 10px;
		min-width: 0;
	}

	.message-content .og-markdown-content > :first-child {
		margin-top: 0;
	}

	.message-content .og-markdown-content > :last-child {
		margin-bottom: 0;
	}

	.attachments {
		font-size: 12px;
		margin-top: 8px;
		padding-top: 5px;
		border-top: 1px solid var(--og-border-color);
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		gap: 5px;
	}

	.attachments:empty {
		display: none;
	}

	.og-markdown-content img:not(.emoji) {
		display: block;
		margin-left: auto;
		margin-right: auto;
		opacity: 0.5;
		transition: opacity 0.4s ease-in-out;
	}

	.og-markdown-content img.loaded {
		opacity: 1;
	}

	.og-markdown-content img.emoji {
		width: 1em;
		height: 1em;
		vertical-align: -0.1em;
	}
`;
